// TIME UTILITIES
const parseTime = (time) => {
  if (!time || typeof time !== 'string' || !time.includes(':')) {
    return { hour: 0, minute: 0 };
  }
  const [hour, minute] = time.split(':').map(Number);
  return { hour, minute };
};

const formatTime = (hour, minute) => {
  const normalizedHour = hour < 0 ? 24 + hour : hour;
  return `${String(normalizedHour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
};

const subtractHour = (hour, amount = 1) => {
  const result = hour - amount;
  return result < 0 ? 24 + result : result;
};

// WITH DRIVER LOGIC ONLY
const calculateWithDriverEndTime = ({ bookingEndTime, overtimeValue }) => {
  if (!overtimeValue || overtimeValue <= 0) {
    return bookingEndTime;
  }

  const { hour, minute } = parseTime(bookingEndTime);
  const newHour = subtractHour(hour, overtimeValue);

  return formatTime(newHour, minute);
};

// MAIN HELPER
export const calculateEndBookingTime = ({ pathName, orderData, overtimeWithDriver, dayDuration }) => {
  const isWithoutDriver = pathName === 'without-driver';

  if (isWithoutDriver) {
    return orderData?.order_detail?.end_booking_time || null;
  }

  // WITH DRIVER
  const lastDay = dayDuration?.[dayDuration.length - 1];

  if (!lastDay) return null;

  const overtimeValue = overtimeWithDriver.find((ovt) => ovt.id === lastDay.overtime_duration)?.value || 0;

  return calculateWithDriverEndTime({
    bookingEndTime: lastDay.booking_end_time,
    overtimeValue,
  });
};
